module.exports = __webpack_public_path__ + "img/logo_iportal_innovators_white.0783c85e.svg";